import React from "react";

import { useTranslation } from "react-i18next";

import APIAllied from "./APIAllied";

interface Props {
  tabName: string;
  onChange?: (hasUnsavedChanges?: boolean) => void;
}

const IntegrationsTab = ({ tabName, onChange }: Props) => {
  const { t: translate } = useTranslation();

  const getCurrentPage = () => {
    switch (tabName) {
      case "apiAllied":
        return <APIAllied onChange={onChange} />;
      default:
        return null;
    }
  };

  return getCurrentPage();
};

export default IntegrationsTab;
